import SidebarHeading from '@github-ui/marketplace-common/SidebarHeading'
import {Stack, Link} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import {orgHovercardPath} from '@github-ui/paths'
import type {FeaturedCustomer} from '../../../types'

export type CustomersProps = {
  customers: FeaturedCustomer[]
}

export function Customers({customers}: CustomersProps) {
  return customers.length ? (
    <Stack gap="condensed" data-testid="featured-customers">
      <SidebarHeading title="Customers" htmlTag="h2" count={customers.length} />
      <span>
        {customers.map(customer => (
          <Link
            key={customer.displayLogin}
            href={`/${customer.displayLogin}`}
            data-hovercard-type="organization"
            data-hovercard-url={orgHovercardPath({owner: customer.displayLogin})}
          >
            <GitHubAvatar
              square
              className="mb-1 mr-1"
              size={32}
              src={customer.image || ''}
              alt={customer.displayLogin}
            />
          </Link>
        ))}
      </span>
    </Stack>
  ) : null
}

try{ Customers.displayName ||= 'Customers' } catch {}